/**
 * API layer danh mục BĐS — lấy danh sách category công khai.
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

/** Các hàm gọi API danh mục. */
export const categoryApi = {
  /** Lấy toàn bộ danh mục kèm số tin đăng. */
  getCategories: () => apiClient.get(API_ROUTES.categories),
};
